import { render, staticRenderFns } from "./PageSearchDataList.vue?vue&type=template&id=50087704&scoped=true"
import script from "./PageSearchDataList.vue?vue&type=script&lang=js"
export * from "./PageSearchDataList.vue?vue&type=script&lang=js"
import style0 from "./PageSearchDataList.vue?vue&type=style&index=0&id=50087704&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "50087704",
  null
  
)

export default component.exports